import { useSearchParams } from "react-router-dom";

export const useGetQueryParams = ({ params }: { params: string[] }) => {
  const [queryParams] = useSearchParams();

  return Object.fromEntries(params.map((param) => [param, queryParams.get(param)]));
};
